import { Notification } from "element-ui";
import { isEmpty } from "./utils";
import actions from "@/store/shardActions";
import store from "@/store";

let webSocket = null;
let socketOpen = false;

// 重连时间间隔 s  ,需要设置的比超时时间长2-3s左右  ，不然会大概率出现建立两个的情况
const retryTimesInterval = 20;
// 超时时间 s ,  过了这个时间没收到心跳或者任何消息，认为链接已经断掉了 ，同时  建立连接超过这个时间 认为建立失败
const timeOutMinutes = 15;
// 断线重试次数
const retries = 30;
// 定时器队列
let timers = [];

// 重连方法
function retry() {
  console.log("开始执行重连");

  let flag = 1;
  let interval = window.setInterval(() => {
    if (socketOpen == false) {
      if (flag < retries) {
        flag++;
        contactSocket()
          .then(() => {
            // 表明当前已连接上  取消重试 清空定时器
            console.log(
              `当前重试次数：${flag},每次重连时间间隔：${retryTimesInterval}`
            );
            clearInterval(interval);
          })
          .catch((err) => {
            console.log(err);
            console.log(` 第${flag}次重试建立连接失败`);
          });
      } else {
        // 当前已超过最大重试次数  直接断连
        Notification.error("ws 当前已超过最大重连次数，停止重连");
        clearInterval(interval);
      }
    } else {
      Notification.error("ws 经重试 已连接");
      clearInterval(interval);
    }
  }, retryTimesInterval * 1000);
}
// 重连定时器
let retryInterval = {};

// 建立连接定时器,
let createTimeOut = {};

// 发送消息方法
const doSend = (message) => {
  if (socketOpen) {
    webSocket.send(message);
  }
};
// 建立链接方法
const contactSocket = () => {
  return new Promise((resolve, reject) => {
    let token = actions.getGlobalState("accessToken");
    if (!isEmpty(token)) {
      console.log("token", token);
      console.log("WebSocket" in window);
      if ("WebSocket" in window) {
        // TODO 我咋判断 当前是http 还是 https
        const isProduction = process.env.NODE_ENV === "production";
        let webSocketUrl = isHttp() ? "ws:" : "wss:";

        if (isProduction) {
          webSocketUrl += `${location.host}/v2/notice/${token}`;
          // webSocket = new WebSocket(`ws:${location.host}/v2/notice/${token}`);
        } else {
          // webSocket = new WebSocket(
          // `ws://${getDevOrigin()}/v2/notice/${token}`
          // );
          webSocketUrl += `//${getDevOrigin()}/v2/notice/${token}`;
        }
        webSocket = new WebSocket(webSocketUrl);

        console.log("webSocket 建立地址", webSocket.url);

        // 建立连接超时  认为建立连接失败
        createTimeOut = window.setTimeout(() => {
          if (webSocket.readyState != 1) {
            // 建立失败
            webSocket.close();
            // 移除
            webSocket = null;
            reject();
          }
        }, timeOutMinutes * 1000);
        // readyState 为1时调用
        webSocket.onopen = function () {
          console.log("连接成功！");
          // 移除建立连接失败定时器
          clearTimer(createTimeOut);
          socketOpen = true;
          console.log("建立成功,可以进行通信");
          // doSend("我寻思你们就离谱")

          // 建立成功后  开启监听重连状态
          retryInterval = window.setInterval(() => {
            if (!isEmpty(webSocket) && socketOpen == false) {
              // 检测到异常情况 已断开， 关闭异常webSocket   直接开始重连
              console.log("重连定时器 监听 webSocket状态,当前*****已断开");
              webSocket.close();
              // 启动重连机制，
              retry();
              clearTimeout(retryInterval);
            }
            console.log("重连定时器 监听 webSocket状态,当前状态正常");
          }, timeOutMinutes * 1000);
          // 只有在 建立成功的时候  resolve ,其他情况让后面的逻辑  一直等到建立成功
          resolve();
        };
        webSocket.onmessage = function (evt) {
          clearTimer(createTimeOut);
          // 每次接受到消息 清空定时器
          timers.forEach((item) => {
            window.clearTimeout(item);
          });
          // console.log(evt);
          let received_msg = evt.data;
          // 自动转化json
          let received_json_msg = JSON.parse(received_msg);
          // 初始化 未读消息数量
          store.commit("wsStore/changeCount", received_json_msg.count);
          // console.log("接受消息：" + evt.data);
          // 每次接受到消息 ，表示当前连接状态正常
          socketOpen = true;
          //  每是十秒会接受心跳  ，如果二十秒没接收到心跳,或者新的消息,认为当前断连 ，进行重连
          if (received_json_msg.type == "HEARTBEAT") {
            resolveMessage(received_json_msg);
            console.log("心跳数据");
          } else {
            resolveMessage(received_json_msg);
          }
          // 接受到消息之后 增加定时器
          timers.push(
            window.setTimeout(() => {
              // 如果超时  将socketOpen 设置为false ，表明链接关闭
              socketOpen = false;
            }, timeOutMinutes * 1000)
          );
        };
        webSocket.onclose = function (e) {
          socketOpen == false;
          // 错误码1000 是正常关闭
          console.error(
            `连接关闭，错误码：${e.code},原因：${e.reason}, 是否正常断开:${e.wasClean}`
          );
          // Notification.warning("连接关闭")
        };
        webSocket.onerror = function () {
          socketOpen == false;
          console.error("连接异常！");
          // Notification.error("连接异常")
        };
      }
    }
  });
};
// 清除ws 所有定时器方法
const clearTimer = () => {
  if (!isEmpty(timers)) {
    timers.forEach((item) => {
      window.clearTimeout(item);
    });
  }

  if (!isEmpty(retryInterval)) {
    window.clearInterval(retryInterval);
  }
  if (!isEmpty(retryInterval)) {
    window.clearTimeout(createTimeOut);
  }
};

const getDevOrigin = () => {
  let splitArray = process.env.VUE_APP_BASE_URL.split("//");
  return splitArray[1].substring(0, splitArray[1].indexOf("/"));
};
// 判断当前是http 还是 https
function isHttp() {
  if (location.protocol == "http:") {
    return true;
  }
  return false;
}
//业务相关消息处理
const resolveMessage = (jsonMessage) => {
  /**
   * jsonMessage:{
   *  type:""，
   *  data::""   标题，
   *  count ：未读消息数量
   *  noticeId:"",
   *  taskId:""
   * }
   */

  // 要根据各种消息类型 ，进行区分     ,  简单内容可以在 js 中写， 复杂内容 需要借助 vue.createElement
  if (jsonMessage.type) {
    store.commit("wsStore/messageDataChange", jsonMessage);
  }
};

export { webSocket, socketOpen, contactSocket, doSend, clearTimer };
